import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { WidgetSettingComposingStrategy } from './strategy/widgetSettingComposing/widgetSettingComposingStrategy'

export const composeDrillDownWidgetSetting = (
  strategy: WidgetSettingComposingStrategy,
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => {
  const drillDownWidgetSetting = {} as DashboardWidgetType

  const keys = Object.keys(widgetSetting) as Array<keyof DashboardWidgetType>

  keys.forEach((key) => {
    if (widgetSetting[key] != null) {
      // @ts-ignore
      drillDownWidgetSetting[key] = widgetSetting[key]!
    }
  })

  if (!strategy.canBeDrilledDown(widgetSetting)) {
    return drillDownWidgetSetting
  }

  if (strategy.isOverMaxInput(insights)) {
    return drillDownWidgetSetting
  }

  return strategy.composeDrillDownWidgetSetting(drillDownWidgetSetting, insights)
}

export default composeDrillDownWidgetSetting
